import React, { useState } from "react";
import styled from "styled-components";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

function ForgotPasswordForm({
	verificationCode,
	resetEmail,
	setResetEmail,
	code,
	setCode,
	newPasswordReset,
	setNewPasswordReset,
	onSendCode,
	onResetPassword,
	onBackToLogin,
	isLoading
}) {
	const [showNewPassword, setShowNewPassword] = useState(false);

	return (
		<>
			<WelcomeText>Recuperar Senha</WelcomeText>
			<SubText>
				{!verificationCode
					? "Informe seu e-mail para receber o código de verificação"
					: "Digite o código recebido e sua nova senha"}
			</SubText>
			{!verificationCode ? (
				<>
					<FieldContainer>
						<TextField
							fullWidth
							InputLabelProps={{ shrink: true }}
							label="E-mail"
							value={resetEmail}
							onChange={(e) => setResetEmail(e.target.value)}
							variant="outlined"
						/>
					</FieldContainer>
					<ContainerButtons>
						<ButtonOptions>
							<CustomButton
								onClick={onSendCode}
								disable={isLoading}
							>
								<CustomButtonLabel>
									{isLoading ? <CircularProgress size={20} /> : "Enviar Código"}
								</CustomButtonLabel>
							</CustomButton>
						</ButtonOptions>
					</ContainerButtons>
				</>
			) : (
				<>
					<FieldContainer>
						<TextField
							fullWidth
							InputLabelProps={{ shrink: true }}
							label="Código de Verificação"
							value={code}
							onChange={(e) => setCode(e.target.value)}
							variant="outlined"
						/>
					</FieldContainer>
					<FieldContainer>
						<TextField
							fullWidth
							InputLabelProps={{ shrink: true }}
							label="Nova Senha"
							type={showNewPassword ? "text" : "password"}
							value={newPasswordReset}
							onChange={(e) => setNewPasswordReset(e.target.value)}
							variant="outlined"
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											onClick={() => setShowNewPassword(!showNewPassword)}
											edge="end"
										>
											{showNewPassword ? <Visibility /> : <VisibilityOff />}
										</IconButton>
									</InputAdornment>
								),
							}}
						/>
					</FieldContainer>
					<ContainerButtons>
						<ButtonOptions>
							<CustomButton
								onClick={onResetPassword}
								disable={isLoading}
							>
								<CustomButtonLabel>
									{isLoading ? <CircularProgress size={20} /> : "Redefinir Senha"}
								</CustomButtonLabel>
							</CustomButton>
						</ButtonOptions>
					</ContainerButtons>
				</>
			)}
			<BackToLoginLink onClick={onBackToLogin}>
				← Voltar para o login
			</BackToLoginLink>
		</>
	);
}

export default ForgotPasswordForm;

const WelcomeText = styled.h2`
	font-size: 28px;
	font-weight: 700;
	color: #2c3e50;
	margin-bottom: 8px;
	font-family: 'Mulish', sans-serif;
`;

const SubText = styled.p`
	font-size: 14px;
	color: #7f8c8d;
	margin-bottom: 32px;
	font-family: 'Mulish', sans-serif;
`;

const FieldContainer = styled.div`
	display: flex;
	margin-bottom: 30px;
	margin-right: 10px;
	flex: 1;
`;

const BackToLoginLink = styled.div`
	text-align: center;
	margin-top: 24px;
	font-size: 14px;
	color: #667eea;
	cursor: pointer;
	font-family: 'Mulish', sans-serif;
	transition: color 0.2s ease;

	&:hover {
		color: #764ba2;
	}
`;

const ContainerButtons = styled.div`
	display: flex;
	margin-top: 50px;
	margin-bottom: 20px;
`;

const ButtonOptions = styled.div`
	flex: 1;
`;

const CustomButton = styled.div`
	align-items: center;
	justify-content: center;
	margin-right: 5px;
	padding: 2px 5px 2px 5px;
	background-color: ${(props) => (props.disable ? "#ddd" : "#2c3e50")};
	border-radius: 5px;
	display: flex;
	color: white;
	height: 50px;
	${({ disable }) =>
		!disable &&
		`
     cursor: pointer;
  `}
`;

const CustomButtonLabel = styled.span`
	font-size: 13px;
`;
